import { DEFAULT_CURRENCY } from './config';

const STORAGE_KEY = 'opportunity-pipeline-create-draft';

export const getDefaultStages = () => [
  {
    id: 1,
    name: 'Abordagem',
    description: '',
    color: '#EC4695',
    sla_days: 0,
    status: 'active',
    position: 1,
  },
  {
    id: 2,
    name: 'Apresentação',
    description: '',
    color: '#14B8A6',
    sla_days: 0,
    status: 'active',
    position: 2,
  },
  {
    id: 3,
    name: 'Em negociação',
    description: '',
    color: '#F59E0B',
    sla_days: 0,
    status: 'active',
    position: 3,
  },
  {
    id: 4,
    name: 'Proposta enviada',
    description: '',
    color: '#8B5CF6',
    sla_days: 0,
    status: 'active',
    position: 4,
  },
  {
    id: 5,
    name: 'Finalizado',
    description: '',
    color: '#22C55E',
    sla_days: 0,
    status: 'active',
    position: 5,
  },
];

export const getEmptyDraft = () => ({
  basicInfo: {
    name: '',
    description: '',
    manager_id: null,
    default_currency: DEFAULT_CURRENCY,
    default_value: 0,
  },
  users: [],
  inboxes: [],
  stages: getDefaultStages(),
  lossReasons: [],
});

export const readDraft = () => {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return getEmptyDraft();
    }

    return {
      ...getEmptyDraft(),
      ...JSON.parse(raw),
    };
  } catch (error) {
    return getEmptyDraft();
  }
};

export const writeDraft = nextDraft => {
  const merged = {
    ...getEmptyDraft(),
    ...nextDraft,
  };
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  return merged;
};

export const patchDraft = partial => {
  const current = readDraft();
  return writeDraft({
    ...current,
    ...partial,
  });
};

export const clearDraft = () => {
  window.sessionStorage.removeItem(STORAGE_KEY);
};

export const resetDraft = () => writeDraft(getEmptyDraft());
